<template>
  <v-container fluid>
    <v-layout column wrap>
      <!-- align-center -->
      <v-flex>
        <!-- <h3 class="display-3">Bienvenido</h3> -->

        <!-- <span class="subheading">Este es el sistema de gestión de pacientes y exámenes de RADIODENT.</span> -->

        <v-divider class="my-3"></v-divider>

        <!-- <div class="title mb-3">Consulte el paciente por el rut!</div> -->
      </v-flex>
      <v-flex text-xs-center>
        <v-expansion-panel v-model="panel" expand>
          <v-expansion-panel-content
            v-if="isPatient === false"
            key="search"
            class="theme--dark"
          >
            <template v-slot:header>
              <div class="right text-xs-right white--text">Buscar</div>
            </template>

            <template>
              <v-layout align-center justify-center row fill-height>
                <v-flex xs12 sm6 mb-3>
                  <!-- hide-details -->
                  <v-text-field
                    v-model="rutPaciente"
                    prepend-icon="search"
                    label="Buscar paciente por rut (Ej: 11111111-1)"
                    hint="IDPaciente"
                    autofocus
                    single-line
                    persistent-hint
                    dark
                  ></v-text-field>
                </v-flex>
                <v-btn color="primary" @click="getExamenes">
                  Buscar
                </v-btn>
              </v-layout>
            </template>
          </v-expansion-panel-content>

          <v-expansion-panel-content key="result"
            ><!-- exámenes -->
            <v-card>
              <v-card-title>
                <div class="title">{{ pagename }}</div>
                <v-spacer></v-spacer>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      @click="getExamenes"
                      :loading="loadingExams"
                      v-on="on"
                    >
                      <v-icon dark>refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Recargar listado de exámenes</span>
                </v-tooltip>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="desserts"
                class="elevation-1"
                :pagination.sync="pagination"
                :loading="loadingExams"
              >
                <template v-slot:items="props">
                  <!-- <td>
                    <span v-if="props.item.condicion == 1" class="badge rounded green"></span>
                    <span v-else-if="props.item.condicion == 2" class="badge rounded amber"></span>
                    <span v-else-if="props.item.condicion == 3" class="badge rounded red"></span>
                  </td> -->
                  <td class="px-2 text-xs-center">
                    {{ props.item.numero_archivos }}
                  </td>
                  <td class="px-2 text-xs-center">
                    {{ props.item.fecha_hora_examen }}
                  </td>
                  <!-- <td class="text-xs-left px-2">{{ props.item.tiempo }}</td> -->
                  <td class="text-xs-left px-2">{{ props.item.IDPaciente }}</td>
                  <td class="text-no-wrap text-xs-left px-2">
                    {{ props.item.nombre }}
                  </td>
                  <td class="text-xs-left px-2">{{ props.item.edad }}</td>
                  <!-- <td class="text-xs-left px-2">{{ props.item.correo_paciente }}</td> -->
                  <!-- <td class="text-xs-left px-2">{{ props.item.modalidad }}</td> -->
                  <!-- <td class="text-no-wrap text-xs-left px-2">{{ props.item.medico_informante }}</td> -->
                  <!-- <td class="text-xs-left px-2">{{ props.item.institucion }}</td> -->
                  <!-- <td class="text-xs-left px-2">{{ props.item.nombre_estado }}</td> -->
                  <td class="layout px-0">
                    <v-btn
                      flat
                      icon
                      title="Ver imágenes"
                      color="accent"
                      class="mx-0"
                      :href="'/imagenes/' + props.item.id + '/dcm'"
                      target="_blank"
                    >
                      <!-- @click="viewImage(props.item, props.index)" -->
                      <v-icon>photo_library</v-icon>
                    </v-btn>

                    <v-btn
                      flat
                      icon
                      title="Ver Informe"
                      color="accent"
                      class="mx-0"
                      @click="selectReportView(props.item)"
                      :disabled="
                        props.item.id_estado != 4 && props.item.id_estado != 5
                      "
                    >
                      <v-icon>picture_as_pdf</v-icon>
                    </v-btn>

                    <v-badge
                      v-if="isPatient === false"
                      overlap
                      class="d-inline-flex"
                      color="transparent"
                    >
                      <template v-slot:badge>
                        <span
                          :class="
                            (!props.item.haveDcm ? 'disabled ' : '') +
                              'badge-text accent--text'
                          "
                          >JPG</span
                        >
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Descargar imágenes"
                        color="accent"
                        class="mx-0"
                        :disabled="!props.item.haveDcm"
                        @click="downloadZip(props.item, 'dcm')"
                      >
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </v-badge>

                    <v-badge overlap class="d-inline-flex" color="transparent">
                      <template v-slot:badge>
                        <span
                          :class="
                            (!props.item.haveOtrodcm ? 'disabled ' : '') +
                              'badge-text accent--text'
                          "
                          >DCM</span
                        >
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Descargar DCM"
                        color="accent"
                        class="mx-0"
                        :disabled="!props.item.haveOtrodcm"
                        @click="downloadZip(props.item, 'otrodcm')"
                      >
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </v-badge>

                    <v-badge
                      v-if="isPatient === false"
                      overlap
                      class="d-inline-flex"
                      color="transparent"
                    >
                      <template v-slot:badge>
                        <v-icon
                          :class="
                            (!props.item.haveMod ? 'disabled ' : '') +
                              'accent--text'
                          "
                          >photo_camera</v-icon
                        >
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Descargar fotografías y modelos"
                        color="accent"
                        class="mx-0"
                        :disabled="!props.item.haveMod"
                        @click="downloadZip(props.item, 'mod')"
                      >
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </v-badge>

                    <v-badge
                      v-if="isPatient === false"
                      overlap
                      class="d-inline-flex"
                      color="transparent"
                    >
                      <template v-slot:badge>
                        <span
                          :class="
                            (!props.item.haveStl ? 'disabled ' : '') +
                              'badge-text accent--text'
                          "
                          >STL</span
                        >
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Descargar modelos STL"
                        color="accent"
                        class="mx-0"
                        :disabled="!props.item.haveStl"
                        @click="downloadZip(props.item, 'stl')"
                      >
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </v-badge>

                    <v-btn
                      v-if="isPatient"
                      flat
                      icon
                      title="Enviar email"
                      color="accent"
                      class="mx-0"
                      @click="selectReportEmail(props.item)"
                    >
                      <v-icon>email</v-icon>
                    </v-btn>

                    <v-badge
                      v-if="isPatient === false"
                      overlap
                      class="d-inline-flex"
                      color="success"
                    >
                      <template
                        v-if="props.item.comentarios.length > 0"
                        v-slot:badge
                      >
                        <span>{{ props.item.comentarios.length }}</span>
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Comentar exámen"
                        color="accent"
                        class="mx-0"
                        @click="commentItem(props.item, props.index)"
                      >
                        <v-icon>chat</v-icon>
                      </v-btn>
                    </v-badge>

                    <!-- <v-icon
                      class="mr-2"
                      disabled
                      @click="viewDicom(props.item)"
                    >
                      photo_library
                    </v-icon> -->
                  </td>
                </template>
                <template v-slot:no-data>
                  <v-alert
                    :value="!loadingExams"
                    color="error"
                    icon="warning"
                    transition="scale-transition"
                  >
                    Lo sentimos, no se encontraron exámenes asociados a usted.
                  </v-alert>
                  <v-alert
                    :value="loadingExams"
                    color="info"
                    icon="manage_search"
                    transition="scale-transition"
                  >
                    Estamos trabajando para encontrar los registros de su
                    búsqueda.
                  </v-alert>
                  <v-btn color="primary" @click="getExamenes">Reset</v-btn>
                </template>
                <template v-slot:no-results>
                  <v-alert
                    :value="!loadingExams"
                    color="error"
                    icon="warning"
                    transition="scale-transition"
                  >
                    Lo sentimos, no se encontraron registros para la búsqueda.
                  </v-alert>
                  <v-alert
                    :value="loadingExams"
                    color="amber darken-2"
                    icon="manage_search"
                    transition="scale-transition"
                  >
                    Seguimos trabajando para encontrar los registros de su
                    búsqueda.
                  </v-alert>
                </template>
              </v-data-table>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <template
          ><!-- viewer -->
          <v-container d-none grid-list-sm fluid>
            <v-layout
              row
              wrap
              v-viewer="viewerOptions"
              class="viewer"
              ref="viewer"
            >
              <figure v-for="(image, index) in images" :key="index">
                <img
                  class="responsive-img"
                  :src="image.src"
                  :data-source="image.src"
                  alt="Imagen DCM"
                  width="200"
                />
              </figure>
            </v-layout>
          </v-container>
        </template>

        <v-dialog v-model="dialogComments" persistent>
          <v-card>
            <v-card-title class="headline primary white--text"
              >Comentarios</v-card-title
            >
            <v-card-text>
              <v-list
                v-if="comments.length > 0"
                three-line
                style="height: 250px; overflow-y: scroll;"
              >
                <template v-for="(item, index, key) in comments">
                  <v-list-tile :key="key">
                    <v-list-tile-content>
                      <v-list-tile-title
                        >{{ item.nombre_autor }}
                        <span class="caption grey--text text--lighten-1"
                          >({{ item.correo_autor + " - " + item.alive }})</span
                        ></v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        v-html="item.comentario"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider :key="key"></v-divider>
                </template>
              </v-list>
              <v-alert v-else :value="true" type="warning">
                Sin comentarios por ahora.
              </v-alert>
              <v-divider dark class="my-3"></v-divider>
              <!-- prepend-icon="comment" -->
              <v-textarea
                box
                v-model="newComment"
                label="Agregar comentario"
                background-color="secondary"
                color="primary"
                :loading="loadingComment"
                :readonly="loadingComment"
                autofocus
                counter
              ></v-textarea>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray darken-1" flat @click="dialogComments = false"
                >Cerrar</v-btn
              >
              <v-btn
                color="primary darken-1"
                @click="comentarExamen"
                :disabled="newComment.length === 0"
                :loading="loadingComment"
                >Comentar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogVerInforme" persistent>
          <v-card>
            <v-card-title class="headline primary white--text"
              >Ver Informe</v-card-title
            >
            <v-card-text>
              <template v-for="(informe, index, key) in informesValidados">
                <v-btn flat @click="viewReport(informe)" :key="key">{{
                  informe.nombre
                }}</v-btn>
              </template>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="gray darken-1"
                flat
                @click="dialogVerInforme = false"
                >Cerrar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEmail" persistent>
          <v-card>
            <v-card-title class="headline primary white--text"
              >Enviar Informe por Email</v-card-title
            >
            <v-card-text>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 px-1>
                    <v-combobox
                      :items="informesValidados"
                      v-model="reportSelected"
                      item-text="nombre"
                      item-value="id_informe"
                      label="Seleccione informe a enviar"
                      return-object
                      auto-select-first
                    >
                      <template v-slot:no-data>
                        <span>Sin informes que adjuntar.</span>
                      </template>
                    </v-combobox>
                  </v-flex>

                  <v-flex xs12 sm4 px-1>
                    <v-checkbox
                      v-model="activeToPaciente"
                      label="Recibir una copia?"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm8 px-1>
                    <v-text-field
                      v-model="toPacienteEmail"
                      :rules="emailRules"
                      label="Paciente"
                      :hint="toPaciente"
                      persistent-hint
                      :disabled="!activeToPaciente"
                      :class="activeToPaciente ? '' : 'line-through'"
                    ></v-text-field>
                    <!-- :error="!emailRules && activeToPaciente" -->
                    <!-- @click:prepend="activeToPaciente = !activeToPaciente" -->
                    <!-- :prepend-icon="iconPaciente" -->
                  </v-flex>

                  <v-flex xs12>
                    <v-combobox
                      class="elevation-0 mt-border-bottom"
                      v-model="ccSelected"
                      :items="cc"
                      label="Enviar a:"
                      multiple
                      chips
                      tags
                    >
                      <!-- clearable -->
                      <template v-slot:selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          :selected="data.selected"
                          :disabled="data.disabled"
                          class="v-chip--select-multi"
                          :color="isEmail(data.item) ? 'green' : 'red'"
                          @input="removeChip(data.index, data.parent)"
                          text-color="white"
                          close
                        >
                          <strong>{{ data.item }}</strong>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>

                  <v-divider dark class="my-3"></v-divider>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray darken-1" flat @click="dialogEmail = false"
                >Cerrar</v-btn
              >
              <v-btn color="primary darken-1" @click="sendEmail"
                >Enviar Email</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
          {{ snackText }}
          <v-btn flat @click="snack = false">Cerrar</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { bus } from "./../main";
var moment = require("moment");
const confBase = {
  timeout: 10000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "x-www-form-urlencoded",
  },
  params: {},
};
export default {
  created() {
    // console.log('$route.params', this.$route.params.carrera_id)
    this.logged_user = JSON.parse(localStorage.getItem("logged_user"));

    if (this.isPatient) {
      // console.log('soy paciente', JSON.parse(JSON.stringify(this.logged_user)))
      this.rutPaciente = this.logged_user.login;
      this.getExamenes();
    }

    // if (this.logged_user && this.logged_user.id_perfil == 4) {
    //   this.$router.push({ name: 'Find' })
    // }
    console.log("USER", JSON.parse(JSON.stringify(this.logged_user)));
    // this.getExamen()
  },
  data: (vm) => ({
    pagename: "EXÁMENES",
    logged_user: null,
    panel: [true, false],
    rutPaciente: null,
    snack: false,
    snackColor: "",
    snackText: "",
    dialogComments: false,
    loadingComment: false,
    comments: [],
    newComment: "",
    dialogImages: false,
    images: [],
    imagesSRC: [],
    viewerOptions: {
      toolbar: true,
      url: "data-source",
    },
    viewers: [],
    search: "",
    pagination: {
      sortBy: "fecha_hora_examen",
      descending: true,
    },
    headers: [
      // { text: '#C', value: 'condicion', sortable: false, align: 'center', class:'px-2' },
      {
        text: "I",
        value: "numero_archivos",
        sortable: false,
        align: "center",
        class: "px-2",
      },
      {
        text: "Fecha Examen",
        value: "fecha_hora_examen",
        align: "center",
        class: "px-2",
      },
      // { text: 'Tiempo', value: 'tiempo', class:'px-2' },
      { text: "IDPaciente", value: "IDPaciente", class: "px-2" },
      { text: "Nombre", value: "nombre", class: "px-2" },
      { text: "Edad", value: "edad", class: "px-2" },
      // { text: 'Correo paciente', value: 'correo_paciente', class:'px-2' },
      // { text: 'Mod', value: 'modalidad', class:'px-2' },
      // { text: 'Médico', value: 'medico_informante', class:'px-2' },
      // { text: 'Inst.', value: 'institucion', class:'px-2' },
      // { text: 'Estado', value: 'id_estado', class:'px-2' },
      { text: "Acciones", sortable: false, align: "left", class: "px-2" },
    ],
    loadingExams: false,
    exams: [],
    examSelected: null,
    desserts: [],
    emailRules: [
      // v => !!v || "Correo es requerido",
      (v) => /.+@.+/.test(v) || !v || "El correo debe ser válido",
    ],
    prestacionesSelected: [],
    informes: [],
    dialogVerInforme: false,
    dialogReabrirInforme: false,
    informesValidados: [],
    reportSelected: null,
    dialogEmail: false,
    toSolicitante: "",
    toSolicitanteEmail: "",
    toPaciente: "",
    toPacienteEmail: "",
    activeToPaciente: false,
    cc: [],
    textCC: "",
    ccSelected: null,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    imageIndicator() {
      return this.selIndex + 1 + "/" + this.imagesSRC.length;
    },
    iconPaciente() {
      return this.activeToPaciente ? "check_box" : "check_box_outline_blank";
    },
    isPatient() {
      // return this.logged_user.id_perfil == 5
      return this.logged_user.type == "paciente";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    startDate() {
      this.startDateFormatted = this.formatDate(this.startDate);
    },
    endDate() {
      this.endDateFormatted = this.formatDate(this.endDate);
    },
  },

  methods: {
    /*
      getExamen () {
        this.loadingExams = true
        Promise.all(
          [this.getExamenes(), this.getUsuariosPerfiles(), this.getEstados(), this.getInstituciones()]
        ).then(response => {
          this.snackColor = 'success'
          this.snackText = 'Datos cargados exitosamente.'
          this.snack = true
        }).catch(reason => {
          this.snackColor = 'error'
          this.snackText = reason
          this.snack = true
          setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
        }).finally(() => {
          this.loadingExams = false
        })
      },
      */

    getExamenes() {
      this.loadingExams = true;
      let rutPaciente = this.rutPaciente.trim();
      this.panel = this.isPatient ? [true] : [false, true];

      if (!this.isRut(rutPaciente)) {
        this.snackColor = "error";
        this.snackText = "El rut no es válido.";
        this.snack = true;
        this.loadingExams = false;
        throw new TypeError("El rut no es válido.");
      }

      confBase.params = {
        accion: "rutExamenes",
        rutPaciente: rutPaciente,
        api_token: this.logged_user.api_token,
      };
      axios
        .create(confBase)
        .get(window.base_path + window.ws)
        .then((result) => {
          this.loadingExams = false;
          if (result.data.response && result.data.callback) {
            // console.log(
            //   "exámenes",
            //   JSON.parse(JSON.stringify(result.data.callback))
            // );

            this.desserts = result.data.callback.map((examen) => {
              examen.numero_archivos = examen.archivos.length;
              examen.haveDcm =
                examen.archivos.filter((el) => el.tipo == "dcm").length > 0;
              examen.haveOtrodcm =
                examen.archivos.filter((el) => el.tipo == "otrodcm").length > 0;
              examen.haveMod =
                examen.archivos.filter((el) => el.tipo == "mod").length > 0;
              examen.haveStl =
                examen.archivos.filter((el) => el.tipo == "stl").length > 0;
              examen.informes.forEach((informe) => {
                informe.prestaciones = informe.prestaciones_informe.map(
                  (prestacionid) => {
                    return examen.prestaciones.find(
                      (el) => el.id_prestacion == prestacionid
                    );
                  }
                );
                informe.nombre = informe.prestaciones
                  .map(function(elem) {
                    return elem.nombre_prestacion;
                  })
                  .join(" y ");
              });
              examen.comentarios.forEach((comentario) => {
                comentario.alive = moment(comentario.fecha_registro)
                  .locale("es")
                  .fromNow();
              });
              examen.archivosURL = window.base_path + window.filesDCM;
              return examen;
            });

            // console.log('exámenes',JSON.parse(JSON.stringify(this.desserts)))
            this.snackColor = "success";
            this.snackText = "Datos cargados exitosamente.";
          } else {
            // console.log('No data result')
            this.snackColor = "error";
            this.snackText = result.data.message;
            // setTimeout(() => {
            //   bus.$emit("userStatus", {
            //     isLogged: false,
            //     message: "Sesión de usuario finalizada",
            //   });
            // }, 1000);
          }
          this.snack = true;
        })
        .catch((error) => {
          console.log("Error ajax");
          this.snackColor = "error";
          this.snackText = error;
          this.snack = true;
          this.loadingExams = false;
          // setTimeout(() => {
          //   bus.$emit("userStatus", {
          //     isLogged: false,
          //     message: "Sesión de usuario finalizada",
          //   });
          // }, 1000);
        });
    },

    selectPrestations(item) {
      this.examSelected = item;
      this.informarPrestaciones = item.prestaciones.filter(
        (el) => el.informado === 0
      );
      this.informes = item.informes.filter((el) => el.validado_informe == 0);
      if (
        this.informarPrestaciones.length === 1 &&
        this.informes.length === 0
      ) {
        //console.log('informarPrestaciones', this.informarPrestaciones.pop().id_prestacion)
        this.prestacionesSelected.push(
          this.informarPrestaciones.pop().id_prestacion
        );
        this.reportItem({ prestaciones: this.prestacionesSelected });
      }
      this.dialogInformar = true;
    },

    selectReportView(item) {
      this.examSelected = item;
      this.informesValidados = item.informes.filter(
        (el) => el.validado_informe == 1
      );
      this.dialogVerInforme = true;
    },

    viewReport(report) {
      console.log("ver", report.id_informe);
      this.loadingExams = true;

      confBase.params = {
        accion: "informePDF",
        id_informe: report.id_informe,
        api_token: this.logged_user.api_token,
      };

      axios
        .create(confBase)
        .get(window.base_path + window.ws)
        .then((result) => {
          console.log("result", JSON.parse(JSON.stringify(result)));
          if (result.data.response) {
            window.open(result.data.ruta, "_blank");
            // let base64data
            // var blob = new Blob([result.data])
            // const url = window.URL.createObjectURL(blob);
            // window.open(url, '_blank')

            // var reader = new FileReader()
            // reader.readAsDataURL(blob);
            // reader.onloadend = function() {
            //   base64data = reader.result
            //   console.log(base64data)

            //   const link = document.createElement('a')
            //   link.href = base64data
            //   link.setAttribute('download', 'informe_'+report.nombre+'.pdf'); //or any other extension
            //   link.setAttribute('target', '_blank')
            //   document.body.appendChild(link)
            //   //console.log('link', link)
            //   link.click()
            // }
          } else {
            // console.log('no link')
            this.snackColor = "error";
            this.snackText = "El informe del exámen no fué encontrado.";
            this.snack = true;
          }
        })
        .catch((error) => {
          // console.log('error', JSON.parse(JSON.stringify(result)))
          // this.snackColor = 'error'
          // this.snackText = error.response
          // this.snack = true
          // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
        })
        .then(() => {
          this.loadingExams = false;
          this.snack = false;
        });
    },

    commentItem(val, index) {
      this.examSelected = val;
      this.examSelected.index = index;
      this.comments = val.comentarios;
      this.dialogComments = true;
    },

    comentarExamen() {
      // console.log('comentando')

      this.loadingComment = true;

      var contentData = {
        accion: "comentarios",
        opcion: "comentarExamen",
        id_examen: this.examSelected.id,
        comentario: this.newComment,
        api_token: this.logged_user.api_token,
      };

      axios({
        method: "post",
        withCredentials: true,
        url: window.base_path + window.ws,
        data: contentData,
      })
        .then((result) => {
          // console.log(result)
          if (result.data.response) {
            this.snackColor = "success";
            this.snackText = result.data.mensaje;
            const now = moment().format();
            let addComment = {
              comentario: this.newComment,
              correo_autor: this.logged_user.email,
              fecha_registro: now,
              alive: moment(now)
                .locale("es")
                .fromNow(),
              id_autor: this.logged_user.id,
              id_comentario: "0",
              nombre_autor:
                this.logged_user.nombres + " " + this.logged_user.apellidos,
            };
            // console.log('examSelected', JSON.parse(JSON.stringify(this.examSelected)))
            setTimeout(() => {
              //this.exams[this.examSelected.index].comentarios.push(addComment)
              this.examSelected.comentarios.unshift(addComment);
              this.newComment = "";
              this.loadingComment = false;
            }, 1000);
          } else {
            this.snackColor = "error";
            this.snackText = result.data.message;
          }
          this.snack = true;
        })
        .catch((error) => {
          // console.log('error',error)
          this.snackColor = "error";
          this.snackText = error.response;
          this.snack = true;
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada",
            });
          }, 1000);
        })
        .then(() => {
          this.loadingComment = false;
        });
    },

    // viewDicom (item) {
    // CR.1.2.392.200036.9125.9.0.253518703.253362207.688224813
    // window.open('http://rd.nubedesign.cl/radiodent/DicomWebViewer/app/?image='+item.archivos[0].dcm.ArchivoDCM, '_blank')
    // },

    inited(viewer) {
      this.$viewer = viewer;
    },

    getImageURL(image) {
      return window.base_path + window.filesDCM + image;
    },

    async viewImage(item, index) {
      console.log("item", index, JSON.parse(JSON.stringify(item)));
      this.images = item.archivos.filter((file) => file.tipo == "dcm");
      this.images.forEach((dcm) => {
        dcm.src = window.base_path + window.filesDCM + dcm.ArchivoJPG;
      });
      this.loadingExams = true;
      setTimeout(() => {
        this.$refs["viewer"].$viewer.show();
        this.loadingExams = false;
      }, 1000);
    },

    /*downloadZip (item) {
        console.log('descargar', item.id)
        this.loadingExams = true

        const confFile = {
          timeout: 10000,
          withCredentials: true,
          responseType: 'blob',
          params: {
            accion: 'comprimirArchivos',
            id_examen: item.id,
            api_token: this.logged_user.api_token
          }
        }

        axios
          .create(confFile)
          .get(window.base_path + window.ws)
          .then(result => {
            // console.log('result', JSON.parse(JSON.stringify(result)), result.data.toString.length, typeof result.data.toString)
            if(result.data) {
              const url = window.URL.createObjectURL(new Blob([result.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'paciente_'+item.IDPaciente+'.zip'); //or any other extension
              document.body.appendChild(link);
              // console.log('link')
              link.click();
            }else {
              // console.log('no link')
              this.snackColor = 'error'
              this.snackText = 'las imagenes de exámen no fueron encontradas.'
              this.snack = true
            }
          })
          .catch(error => {
              console.log('error', JSON.parse(JSON.stringify(result)))
              // this.snackColor = 'error'
              // this.snackText = error.response
              // this.snack = true
              // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          })
          .then(() => {
            this.loadingExams = false
            this.snack = false
          })
      },
      */
    downloadZip(item, tipo) {
      // console.log('descargar', tipo, JSON.parse(JSON.stringify(item)))
      this.loadingExams = true;
      let files = item.archivos.filter((file) => file.tipo == tipo);

      // if (tipo === 'otrodcm') {
      //   window.open(files[0].url, '_blank')
      //   this.loadingExams = false
      //   return
      // }
      // console.log('Files', tipo, JSON.parse(JSON.stringify(files)))
      var numFiles = files.length;
      // console.log('numFiles', numFiles)
      const confFile = {
        timeout: 0,
        withCredentials: true,
        responseType: "blob",
        params: {
          accion: "comprimirArchivos",
          id_examen: item.id,
          tipo_archivo: tipo,
          api_token: this.logged_user.api_token,
        },
      };

      axios
        .create(confFile)
        .get(window.base_path + window.ws)
        .then((result) => {
          // console.log('result download', JSON.parse(JSON.stringify(result)), result.data.toString.length, typeof result.data.toString)
          if (result.data) {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement("a");
            // let ext = numFiles === 1 && (tipo === 'dcm' || tipo === 'mod') ? '.jpg' : '.zip'
            let ext;
            if (numFiles > 1) {
              ext = ".zip";
            } else {
              switch (tipo) {
                case "stl":
                  ext = ".stl";
                  break;
                case "otrodcm":
                  ext = ".dcm";
                  break;
                default:
                  ext = ".jpg";
                  break;
              }
            }
            link.href = url;
            link.setAttribute("download", "paciente_" + item.IDPaciente + ext); //or any other extension
            document.body.appendChild(link);
            // console.log('link')
            link.click();
          } else {
            // console.log('no link')
            this.snackColor = "error";
            this.snackText = "las imagenes de exámen no fueron encontradas.";
            this.snack = true;
          }
        })
        .catch((error) => {
          //console.log('error', JSON.parse(JSON.stringify(result)))
          this.snackColor = "error";
          this.snackText = error.response;
          this.snack = true;
          // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
        })
        .then(() => {
          this.loadingExams = false;
          this.snack = false;
        });
    },

    selectReportEmail(item) {
      this.reportSelected = null;
      this.examSelected = item;
      this.informesValidados = item.informes.filter(
        (el) => el.validado_informe == 1
      );

      /* this.getSolicitante(this.examSelected.id_solicitante).then(solicitante => {
              console.log('ok', solicitante)
            }).catch(error => {
              console.log('error', error)
            }) */
      // this.toSolicitante = this.examSelected.medico_solicitante;
      // this.toSolicitanteEmail = this.examSelected.correo_solicitante;

      this.toPaciente = this.examSelected.nombre;
      this.toPacienteEmail = this.examSelected.correo_paciente;

      //console.log('this.informesValidados', this.informesValidados)
      if (this.informesValidados.length > 0) {
        //this.reportSelected = this.informesValidados[0]
      } else {
        //nada
      }

      // console.log(JSON.parse(JSON.stringify(this.examSelected)))

      this.dialogEmail = true;
    },

    isEmail(v) {
      if (v.length === 0) {
        return false;
      }
      if (!/.+@.+/.test(v)) {
        return false;
      }
      return true;
    },

    isRut(rutCompleto) {
      rutCompleto = rutCompleto.replace("‐", "-");
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var tmp = rutCompleto.split("-");
      var digv = tmp[1];
      var rut = tmp[0];
      if (digv == "K") digv = "k";

      return this.dv(rut) == digv;
    },

    dv(T) {
      var M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10))
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },

    removeChip(index, parent) {
      // console.log('remove', index, parent)
      this.ccSelected.splice(index, 1);
    },

    sendEmail() {
      let conCopia;

      this.loadingExams = true;

      if (this.ccSelected) {
        conCopia = this.ccSelected.filter((el) => this.isEmail(el)).join(",");
      }
      // console.log('send email', this.reportSelected, this.toSolicitanteEmail, this.toPacienteEmail, conCopia)
      var contentData = {
        accion: this.reportSelected ? "enviarCorreo" : "enviarCorreoSinInforme",
        id_informe: this.reportSelected ? this.reportSelected.id_informe : null,
        id_examen: this.examSelected.id,
        // correo_solicitante: this.toSolicitanteEmail,
        correo_paciente: this.activeToPaciente ? this.toPacienteEmail : null,
        otros_correos: conCopia,
        api_token: this.logged_user.api_token,
      };

      axios({
        method: "post",
        withCredentials: true,
        url: window.base_path + window.ws,
        data: contentData,
      })
        .then((result) => {
          console.log(
            "result enviarCorreo",
            JSON.parse(JSON.stringify(result))
          );
          if (result.data.response) {
            this.snackColor = "success";
            this.snackText = result.data.message; //"Correo enviado exitósamente!"
            this.dialogEmail = false;
          } else {
            this.snackColor = "error";
            this.snackText = result.data.message;
          }
          this.snack = true;
        })
        .catch((error) => {
          // console.log('error',error)
          this.snackColor = "error";
          this.snackText = error.response;
          this.snack = true;
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada",
            });
          }, 1000);
        })
        .then(() => {
          this.loadingExams = false;
        });
    },
  },
};
</script>

<style lang="scss">
.badge {
  width: 10px;
  height: 10px;
  display: block;
  &.rounded {
    border-radius: 50%;
  }
}
.v-badge__badge {
  top: 0 !important;
  right: 0 !important;
}

.line-through {
  text-decoration: line-through;
}
.v-expansion-panel__container.theme--dark {
  background-color: #424242 !important;
}
</style>
